import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import * as S from './TransactionsTabs.styles';
import { ROUTES } from '@/constants/routes';
import { TransactionTabName } from '@/features/Profile/sections/Transactions/Transactions.types';
import { useScrollSelectedTabIntoView } from '@/features/Profile/core/hooks';

interface TransactionsTabsProps {
  activeTab: TransactionTabName;
  isShop: boolean;
}

const TAB_ROUTES: Record<TransactionTabName, string> = {
  [TransactionTabName.Account]: ROUTES.accountTxs,
  [TransactionTabName.Ads]: ROUTES.adsTxs,
  [TransactionTabName.PaidAds]: ROUTES.paidAdsTxs,
};

export const TransactionsTabs = ({
  activeTab,
  isShop,
}: TransactionsTabsProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const tabsRef = useScrollSelectedTabIntoView([activeTab, isShop]);

  function handleTabClick(tab: TransactionTabName) {
    router.replace(TAB_ROUTES[tab], undefined, { scroll: false });
  }

  return (
    <S.Container ref={tabsRef}>
      <S.Tab
        type="button"
        data-selected={activeTab === TransactionTabName.Account}
        $isActive={activeTab === TransactionTabName.Account}
        onClick={() => handleTabClick(TransactionTabName.Account)}
      >
        {t('pages.cabinet.private_account')}
      </S.Tab>

      <S.Tab
        type="button"
        data-selected={activeTab === TransactionTabName.Ads}
        $isActive={activeTab === TransactionTabName.Ads}
        onClick={() => handleTabClick(TransactionTabName.Ads)}
      >
        {t('pages.cabinet.ads')}
      </S.Tab>

      {isShop && (
        <S.Tab
          type="button"
          data-selected={activeTab === TransactionTabName.PaidAds}
          $isActive={activeTab === TransactionTabName.PaidAds}
          onClick={() => handleTabClick(TransactionTabName.PaidAds)}
        >
          {t('pages.cabinet.paid_placements')}
        </S.Tab>
      )}
    </S.Container>
  );
};
